<template>
  <div>
    <v-layout justify-center column ma-4>
      <!-- <div>Choose mail provider below to get started.</div> -->
      
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 48 48" version="1.1" width="60px" height="60px">
          <g id="surface1">
          <path style=" fill:#0288D1;" d="M 42 37 C 42 39.761719 39.761719 42 37 42 L 11 42 C 8.238281 42 6 39.761719 6 37 L 6 11 C 6 8.238281 8.238281 6 11 6 L 37 6 C 39.761719 6 42 8.238281 42 11 Z "/>
          <path style=" fill:#FFFFFF;" d="M 12 19 L 17 19 L 17 36 L 12 36 Z "/>
          <path style=" fill:#FFFFFF;" d="M 14.484375 17 L 14.457031 17 C 12.964844 17 12 15.886719 12 14.5 C 12 13.078125 12.996094 12 14.515625 12 C 16.035156 12 16.972656 13.078125 17 14.5 C 17 15.886719 16.035156 17 14.484375 17 Z "/>
          <path style=" fill:#FFFFFF;" d="M 36 36 L 31 36 L 31 26.902344 C 31 24.703125 29.773438 23.203125 27.808594 23.203125 C 26.308594 23.203125 25.496094 24.214844 25.101563 25.191406 C 24.957031 25.542969 25 26.511719 25 27 L 25 36 L 20 36 L 20 19 L 25 19 L 25 21.617188 C 25.722656 20.5 26.851563 19 29.738281 19 C 33.316406 19 36 21.25 36 26.273438 Z "/>
          </g>
        </svg>
      
      <v-layout mb-3 justify-center>
         <h3>Choose an account to cancel request on <a href="https://linkedin.com">linkedin.com</a></h3>
         
      </v-layout>
      <nav>
        <router-link to="/outlook-email-form">
          <v-btn class="white--text" block color="#015DA5" >
            <!-- <v-icon left>thumb_up</v-icon> -->
            <v-spacer></v-spacer>
            Outlook - Office365
            <v-spacer></v-spacer>
          </v-btn>
        </router-link>
        <v-divider></v-divider>
        <!-- <router-link to="/google-email-form">
          <v-btn class="white--text" block color="#BE3914"> -->
            <!-- <v-icon left>thumb_up</v-icon> -->
            <!-- <v-spacer></v-spacer>
            gmail - GOOGLE DRIVE -->
            <!-- <v-spacer></v-spacer>
          </v-btn>
        </router-link> -->
        <v-divider></v-divider>
        <router-link to="/other-email-form">
          <v-btn class="white--text" block color="secondary" dark>
            <!-- <v-icon left>thumb_up</v-icon> -->
            <v-spacer></v-spacer>
            other mail providers
            <v-spacer></v-spacer>
          </v-btn>
        </router-link>
      </nav>
    </v-layout>
  </div>
</template>
<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "home",
  components: {
  }
};
</script>
<style>
  a {
    text-decoration: none;
  }
</style>